import React from 'react';
import PropTypes from 'prop-types';
import { Hidden, MenuItem, Tabs as MuiTabs, Tab } from '@material-ui/core';

// STYLES
import { Wrapper, SelectStyled, SecondaryTabs } from './styles';

const Tabs = ({
  variant,
  options,
  name,
  onChange,
  onBlur,
  className,
  selectProps,
  tabsProps,
  ...restProps
}) => {
  if (variant === 'secondary') {
    return (
      <SecondaryTabs onChange={(e, val) => onChange(name, val)} {...restProps}>
        {options.map(option => {
          const label = <span>{option.name}</span>;

          return <Tab key={`item-${option.id}`} value={option.id} label={label} {...option} />;
        })}
      </SecondaryTabs>
    );
  }

  return (
    <Wrapper className={className}>
      <Hidden smUp>
        <SelectStyled
          name={name}
          displayEmpty
          onBlur={onBlur}
          onChange={e => onChange(name, e.target.value)}
          {...selectProps}
          {...restProps}
        >
          {options.map(option => {
            return (
              <MenuItem
                key={`device-${option.id}`}
                className="secondary"
                value={option.id}
                {...option}
              >
                {option.name}
                {option.subname && ` ${option.subname}`}
              </MenuItem>
            );
          })}
        </SelectStyled>
      </Hidden>
      <Hidden xsDown>
        <MuiTabs onChange={(e, val) => onChange(name, val)} {...tabsProps} {...restProps}>
          {options.map(option => {
            const label = (
              <>
                <span>{option.name}</span>
                {option.subname && <span className="sub-label">{option.subname}</span>}
              </>
            );
            return <Tab key={`device-${option.id}`} value={option.id} label={label} {...option} />;
          })}
        </MuiTabs>
      </Hidden>
    </Wrapper>
  );
};

Tabs.defaultProps = {
  options: [],
  name: '',
  onChange: () => {},
  className: '',
  selectProps: {},
  tabsProps: {},
  variant: 'primary',
};

Tabs.propTypes = {
  variant: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  options: PropTypes.array,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  selectProps: PropTypes.object,
  tabsProps: PropTypes.object,
};

export default React.memo(Tabs);
